import React from 'react';
import './ScoreSummary.css';

/**
 * Enhanced ScoreSummary component with theme support
 * Shows match score between home and away teams
 */
const ScoreSummary = ({ homeTeamName, awayTeamName, scores }) => {
    return (
        <div className="stats-section">
            <h3 className="stats-section-title">Score Summary</h3>
            <div className="score-summary">
                <div className="team-score-summary home">
                    <div className="team-score-name">{homeTeamName}</div>
                    <div className="team-score-value">{scores.home}</div>
                </div>
                <div className="team-score-divider">-</div>
                <div className="team-score-summary away">
                    <div className="team-score-name">{awayTeamName}</div>
                    <div className="team-score-value">{scores.away}</div>
                </div>
            </div>
        </div>
    );
};

export default ScoreSummary;